// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__-szjk","noPadding":"PageHeader_noPadding__FOWyB"};